import React, { useState } from "react";

import GeoJSONMap from "../../../components/2024/map";
import PieChart from "../../../components/PieChart";
import scheduleData from "../../../components/2024/schedule.json";

export default function AttendMap() {
  const [getId, setGetId] = useState({
    name: "Улсын хэмжээнд",
    id: "",
  });
  const [getInfo, setGetInfo] = useState({
    name: "",
    school_cover: "",
    kinder_cover: "",
  });
  const [lat, setLang] = useState({
    lattitude: "",
    longitude: "",
  });

  const handleFeatureMouseOver = (e) => {
    const name = e.target.feature.properties.name;
    const sub = e.target.feature.properties.sub_coverage;
    const ebs = e.target.feature.properties.ebs_coverage;

    setLang({
      lattitude: e.latlng.lat,
      longitude: e.latlng.lng,
    });

    setGetInfo({
      name: name,
      school_cover: ebs,
      kinder_cover: sub,
    });
  };

  const handleFeatureMouseOut = () => {
    setGetInfo({
      name: null,
      school_cover: null,
      kinder_cover: null,
    });
  };

  const handleFeatureMouseClick = (e) => {
    const info_name = e.target.feature.properties.name;
    const info_id = e.target.feature.properties.aimag_city_ID;

    setGetId({
      name: info_name,
      id: info_id,
    });
  };

  return (
    <div className="container">
      <div class="section-title" data-aos="fade-up">
        <h2>ТООН МЭДЭЭЛЭЛ</h2>
      </div>
      <div style={{ marginBottom: "5px" }}>
        <GeoJSONMap
          handleFeatureMouseOver={handleFeatureMouseOver}
          setGetInfo={setGetInfo}
          getInfo={getInfo}
          handleFeatureMouseOut={handleFeatureMouseOut}
          lat={lat}
          handleFeatureMouseClick={handleFeatureMouseClick}
        />
      </div>
      {getId.name !== "Улсын хэмжээнд" && (
        <>
          <div className="fade-in-box">
            <h2 style={{ color: "#010483" }}>{getId.name}</h2>
          </div>
          <div className="mb-3 fade-in-box">
            {scheduleData?.map(
              (item) =>
                item.aimag_name === getId.name && (
                  <div key={item.aimag_name}>
                    <div
                      className="att-chart-container"
                      style={{ display: "flex", direction: "row" }}
                    >
                      <PieChart
                        label={"Цэцэрлэг"}
                        percent={100}
                        count={item.data.sub}
                        color="#ec4899"
                      />
                      <PieChart
                        label={"Сургууль"}
                        percent={100}
                        count={item.data.ebs}
                        color="#a78bfa"
                      />
                      <PieChart
                        label={"ЕБС оролцогч "}
                        percent={100}
                        count={item.data.ebs * 2}
                        color="#10b981"
                      />
                      <PieChart
                        label={"СӨБ оролцогч"}
                        percent={100}
                        count={item.data.sub * 2}
                        color="#6366f1"
                      />
                    </div>
                  </div>
                )
            )}
          </div>
        </>
      )}

      <div>
        <h2 style={{ color: "#010483" }}>{"Улсын хэмжээнд"}</h2>
      </div>
      <div
        className="att-chart-container"
        style={{ display: "flex", direction: "row" }}
      >
        <PieChart
          label={"Цэцэрлэг"}
          percent={100}
          count={1010}
          color="#ec4899"
        />
        <PieChart
          label={"Сургууль"}
          percent={100}
          count={707}
          color="#a78bfa"
        />
        <PieChart
          label={"ЕБС оролцогч "}
          percent={100}
          count={707 * 2}
          color="#10b981"
        />
        <PieChart
          label={"СӨБ оролцогч"}
          percent={100}
          count={1010 * 2}
          color="#6366f1"
        />
      </div>
    </div>
  );
}
